export default {
  CLEAR_DATA: Symbol('CLEAR_DATA'),
  SAVE_DATA: Symbol('SAVE_DATA'),
  TOGGLE_LOADING: Symbol('TOGGLE_LOADING'),
  SET_PAGINATION: Symbol('SET_PAGINATION'),
  RESET_PAGINATION: Symbol('RESET_PAGINATION'),
  EXTENDED_CHECKIN_DETAIL_LIST: Symbol('EXTENDED_CHECKIN_DETAIL_LIST'),
  LAST_NIGHT_AUDIT_TIME: Symbol('LAST_NIGHT_AUDIT_TIME'),
  CHANNEL_DATA_SOURCE: Symbol('CHANNEL_DATA_SOURCE'),
  ROOM_TYPE_DATA_SOURCE: Symbol('ROOM_TYPE_DATA_SOURCE'),
  ALL_ROOM_TYPE_MAP: Symbol('ALL_ROOM_TYPE_MAP'),
  BILL_LIST: Symbol('BILL_LIST'),
  SPLIT_ROOM_TYPE_LIST: Symbol('SPLIT_ROOM_TYPE_LIST'),
  ORDER_RECEPTION_LIST: Symbol('ORDER_RECEPTION_LIST'),
  ORDER_RECEPTION_PAGE: Symbol('ORDER_RECEPTION_PAGE'),
  ORDER_RESERVATION_LIST: Symbol('ORDER_RESERVATION_LIST'),
  ORDER_RESERVATION_PAGE: Symbol('ORDER_RESERVATION_PAGE'),
  ORDER_DETAIL_BASE_INFO: Symbol('ORDER_DETAIL_BASE_INFO'),
  ORDER_DETAIL_CUSTOMER_INFO: Symbol('ORDER_DETAIL_CUSTOMER_INFO'),
  ORDER_DETAIL_ROOM_INFO: Symbol('ORDER_DETAIL_ROOM_INFO'),
  ORDER_DETAIL_CHECK_ROOM_INFO: Symbol('ORDER_DETAIL_CHECK_ROOM_INFO'),
  STOTE_START_USE_CARD: Symbol('STOTE_START_USE_CARD'),
  IS_CHANGE_MASTER: Symbol('IS_CHANGE_MASTER'),
  OTA_CANCEL_LIST: Symbol('OTA_CANCEL_LIST'),
};
